import { ROLE_FAMILIES, ROLE_VARIANTS } from '../data/roleFamilies.js';

function normalise(value = '') {
  return String(value)
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');
}

export function getRoleFamily(parentRoleKey) {
  return ROLE_FAMILIES[parentRoleKey] || null;
}

export function getRoleVariant(variantKey) {
  return ROLE_VARIANTS.find((variant) => variant.variantKey === variantKey) || null;
}

export function getRoleVariantForParent(parentRoleKey, variantKey) {
  const variant = getRoleVariant(variantKey);
  return variant?.parentRoleKey === parentRoleKey ? variant : null;
}

export function getRoleFamilyParentKey(roleKeyOrVariantKey) {
  if (ROLE_FAMILIES[roleKeyOrVariantKey]) return roleKeyOrVariantKey;
  return getRoleVariant(roleKeyOrVariantKey)?.parentRoleKey || roleKeyOrVariantKey;
}

export function resolveRoleVariantSearch(query) {
  const needle = normalise(query);
  if (!needle) return null;

  return ROLE_VARIANTS.find((variant) => {
    const terms = [
      variant.variantKey,
      variant.title,
      variant.plainEnglishTitle,
      ...(variant.aliases || []),
      ...(variant.searchTerms || []),
    ];
    return terms.some((term) => normalise(term) === needle);
  }) || null;
}

export function resolveRoleVariantFromUrl(search = '') {
  const params = search instanceof URLSearchParams
    ? search
    : new URLSearchParams(String(search || '').replace(/^\?/, ''));
  return getRoleVariant(params.get('variant'));
}

export function createRoleVariantQuery(variantKey) {
  return variantKey ? `&variant=${encodeURIComponent(variantKey)}` : '';
}

export function dedupeRoleFamilyReferences(roleReferences = []) {
  const seenParents = new Set();
  const result = [];

  roleReferences.forEach((reference) => {
    const roleKey = reference?.roleKey || reference?.id || reference;
    if (!roleKey) return;
    const parentRoleKey = getRoleFamilyParentKey(roleKey);
    if (seenParents.has(parentRoleKey)) return;
    seenParents.add(parentRoleKey);
    result.push(reference);
  });

  return result;
}
